export const contractTemplates = [
  {
    id: 'tpl-starter-standard',
    name: 'Standard creator collaboration',
    fileName: 'Creator Collaboration Agreement.pdf',
    fileType: 'PDF',
    fileSize: '248 KB',
    savedAt: '2026-06-18',
    sourceCampaign: '',
    body: `CREATOR COLLABORATION AGREEMENT

This Agreement is made between {{agency}} ("the Agency") and {{creator}} ({{handle}}) ("the Creator"), in respect of the {{campaign}} campaign for {{brand}} ("the Brand").

1. ENGAGEMENT
The Creator is engaged to produce and publish the following deliverables across {{contentTypes}} for the campaign running from {{startDate}} to {{endDate}}:
{{deliverables}}

2. FEE
In consideration of the services, the Agency will pay the Creator {{amount}}. Payment is released once the deliverables are approved and this Agreement has been signed by the Creator.

3. DELIVERABLES
The Creator will submit each deliverable by the agreed dates and will complete up to two rounds of revisions if requested.

4. CONTENT RIGHTS
The Brand receives a licence to reuse the approved content across paid and organic channels for twelve months.

5. TERM & TERMINATION
Either party may terminate on written notice. Deliverables already approved remain payable.

6. DIGITAL SIGNATURE
This Agreement takes effect on the date of the Creator's digital signature. The Creator cannot be activated on the campaign, and no fee is committed, until this Agreement is signed.

Issued {{today}} by {{agency}}.`,
  },
  {
    id: 'tpl-starter-paid-usage',
    name: 'UGC + paid usage agreement',
    fileName: 'UGC Paid Usage Agreement.pdf',
    fileType: 'PDF',
    fileSize: '286 KB',
    savedAt: '2026-07-09',
    sourceCampaign: '',
    body: `USER-GENERATED CONTENT & PAID USAGE AGREEMENT

Between {{agency}} ("the Agency") and {{creator}} ({{handle}}) ("the Creator") for the {{campaign}} campaign on behalf of {{brand}} ("the Brand").

1. SCOPE OF WORK
The Creator will produce the following deliverables in {{contentTypes}} between {{startDate}} and {{endDate}}, delivered as raw, unwatermarked assets:
{{deliverables}}

2. FEE & USAGE
The Agency will pay the Creator {{amount}} for the production of the content. This fee includes a paid-media usage licence for the Brand's own channels for six months from first publication.

3. WHITELISTING
Where the Creator grants access, the Brand may run the content as an ad from the Creator's own handle for the licence period. Any extension of the licence period or new markets requires a separate fee agreed in writing.

4. EXCLUSIVITY
During the campaign the Creator will not promote a directly competing product in the same category without the Agency's written consent.

5. APPROVALS
The Brand may request one round of edits before publication. The Creator will not publish before written approval.

6. DIGITAL SIGNATURE
No fee is committed and the Creator cannot be activated on the campaign until this Agreement is signed digitally.

Issued {{today}} by {{agency}}.`,
  },
  {
    id: 'tpl-starter-ambassador',
    name: '12-month ambassador retainer',
    fileName: 'Brand Ambassador Retainer.pdf',
    fileType: 'PDF',
    fileSize: '312 KB',
    savedAt: '2026-07-28',
    sourceCampaign: '',
    body: `BRAND AMBASSADOR RETAINER AGREEMENT

This Retainer Agreement is made between {{agency}} ("the Agency") and {{creator}} ({{handle}}) ("the Ambassador") in respect of the {{campaign}} programme for {{brand}} ("the Brand").

1. TERM
The retainer runs from {{startDate}} to {{endDate}}. Content will be produced across {{contentTypes}} as part of an ongoing programme.

2. RETAINER FEE
The Agency will pay the Ambassador {{amount}} for the term, released monthly against approved deliverables. The deliverables for the term are:
{{deliverables}}

3. AMBASSADOR DUTIES
The Ambassador will represent the Brand positively across their channels for the duration of the term, including at up to two virtual events per quarter where reasonably requested.

4. CATEGORY EXCLUSIVITY
The Ambassador will not promote competing brands in the same category for the full term without the Agency's written consent.

5. REVIEW MILESTONES
Performance is reviewed every quarter. Either party may adjust the scope with thirty days' written notice.

6. DIGITAL SIGNATURE
This Retainer takes effect on the date of the Ambassador's digital signature. The Ambassador cannot be activated on the programme until this Agreement is signed.

Issued {{today}} by {{agency}}.`,
  },
];